// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"OrfAM8","animatedgradient":"QABM_U","button":"y_OB6P","icon":"GugUIi","iconAnimate":"JIm6Nd"};